<template>
    <div class="h-100 d-flex justify-center align-center flex-column">
      <v-icon color="warning" size="100px">mdi-calendar-remove</v-icon>
      <h2>Payment Failed</h2>
      <!-- <h2>{{message}}</h2> -->
      <!-- {{ pymtDetails }} -->
      <div class="mt-8">
        <v-btn color="primary" block @click="$router.push({name:'Home'})">Back</v-btn>
      </div>
    </div>
  </template>
  <script>
  export default {
    props: {
      
    },
    mounted() {
      
  },
   methods: {
   }
  };
  </script>
  